





















import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

@Component
export default class ReadMore extends Vue {
    protected readMoreText: string = this.$attrs['data-text'];
    protected cssClassContainer: string = this.$attrs[
        'data-css-class-container'
    ];
    protected sassBackgroundColorName: string = this.$attrs[
        'data-sass-background-color-name'
    ];
    protected cssClassText: string = this.$attrs['data-css-class-text'];
    protected contracted: boolean = true;
    protected hideAll: boolean = false;
    protected toggleDisabled: boolean = false;
    protected toggleDisabledDesktop: boolean = false;
    protected minimumLenght: number = parseInt(
        this.$attrs['data-minimum-letter-length-for-toggle'],
        10
    );

    constructor() {
        super();

        if (this.$attrs['data-toggle-disabled-desktop'] == 'true') {
            this.toggleDisabledDesktop = true;
        } else {
            // console.log(
            //     'toolgle able',
            //     this.$attrs['data-toggle-disabled-desktop']
            // );
        }
    }

    mounted() {
        this.calculateTextLenght();
    }

    calculateTextLenght() {
        if (
            this.readMoreText === null ||
            this.readMoreText === undefined ||
            this.readMoreText.length === 0
        ) {
            this.hideAll = true;
        } else if (this.readMoreText.length < this.minimumLenght) {
            this.toggleDisabled = true;
        }
    }

    private toggleExpand(e: any) {
        const srcElement = e.srcElement;

        if (srcElement.classList.contains('open') || this.contracted) {
            this.contracted = !this.contracted;
        }
    }
}
